import { useEffect, useState } from "react";
import { ViewingOrgProvider } from "@/contexts/viewing-org-context";
import { StageRail } from "./stage-rail";
import { Topbar } from "./topbar";

export function MainLayout({ children }: { children: React.ReactNode }) {
  const [isStageRailOpen, setIsStageRailOpen] = useState(false);

  useEffect(() => {
    document.documentElement.classList.add("portal-app-shell");
    return () => document.documentElement.classList.remove("portal-app-shell");
  }, []);

  return (
    <ViewingOrgProvider>
    <div className="flex h-full min-h-0 overflow-hidden bg-gray-50">
      {/* Stage Rail - Hidden on mobile/tablet, shown on desktop */}
      <div className="hidden lg:block min-h-0 h-full shrink-0">
        <StageRail />
      </div>
      
      {/* Mobile/Tablet Stage Rail Overlay */}
      {isStageRailOpen && (
        <>
          {/* Backdrop */}
          <div 
            className="fixed inset-0 bg-black/50 z-40 lg:hidden"
            onClick={() => setIsStageRailOpen(false)}
          />
          {/* Drawer */}
          <div className="fixed left-0 top-0 bottom-0 z-50 lg:hidden">
            <StageRail onClose={() => setIsStageRailOpen(false)} />
          </div>
        </>
      )}

      <div className="flex-1 flex flex-col min-h-0 overflow-hidden w-full">
        <Topbar onMenuClick={() => setIsStageRailOpen(!isStageRailOpen)} />
        <main className="flex-1 min-h-0 overflow-y-auto p-3 sm:p-4 lg:p-6">{children}</main>
      </div>
    </div>
    </ViewingOrgProvider>
  );
}







